export default function Home() {
  return (
    <div className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-sky-700 via-blue-800 to-indigo-900 px-4 text-center">
      <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-sky-400/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -right-24 h-96 w-96 rounded-full bg-indigo-400/20 blur-3xl" />

      <div className="relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-sm font-medium text-white/90 backdrop-blur-sm">
          <i className="ri-cloud-line text-base leading-none" />
          Hosting Environment
        </span>

        <h1 className="font-heading text-4xl font-bold leading-tight tracking-tight text-white drop-shadow-sm md:text-6xl">
          AWS Hosting Test
        </h1>

        <p className="mt-6 max-w-xl text-base leading-relaxed text-white/80 md:text-lg">
          このサイトはAWSホスティングのテスト用です
        </p>
      </div>
    </div>
  );
}